module.exports = __webpack_public_path__ + "static/mardi_gras-fe6f1f4f570a610e0fd662cad0832647.png";